import { images } from "../../../Assets/assetsHelper";
import "./Profile.css";
import React, { useState } from "react";
import FormModal from "../../../Components/Molecules/FormModal/FormModal";
import { useNavigate } from "react-router-dom";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { PulseLoader } from "react-spinners";
import PrimaryButton from "../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { BaseURL } from "../../../Hooks/URL";
import { Fetch } from "../../../Hooks/Fetch";
import config from "../../../config";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: 8,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 8,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Profile({ Open, setOpen, profile, loading, contextData }) {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      <FormModal
        Open={Open}
        HandleClose={() => {
          setOpen(false);
        }}
        Form={<></>}
        Title={"Edit Profile"}
      />
      {!loading ? (
        <div className="ProfileCont">
          <div className="greyBoxVer">
            <Typography
              sx={{
                fontSize: { xs: "20px", md: "22px" },
                fontWeight: "600",
                marginBottom: "4px",
              }}
            >
              AI Challenge Online Championship
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                fontWeight: "400",
                marginBottom: "20px",
              }}
            >
              Please complete the steps below to successfully finish your
              submission.
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Step 1: Create Account */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor: "success.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: "500",
                    }}
                  >
                    Login to your account
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      color: "text.secondary",
                    }}
                  >
                    You've successfully logged in to your account and are ready
                    to start your journey!
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor: "success.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  1
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", md: "18px" },
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    Submit your solutions
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", md: "16px" },
                      color: "text.secondary",
                      mb: 0.5,
                    }}
                  >
                    Start by submitting your code for all the missions.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </div>

          <div className="greyBoxVer">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                marginBottom: "10px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "20px", md: "22px" },
                  fontWeight: "600",
                }}
              >
                Team Details:
              </Typography>
              {/* <a
                target="_blank"
                href={`${BaseURL}/account/dashboard/home/pdf?timeZone=${
                  Intl.DateTimeFormat().resolvedOptions().timeZone ??
                  "Africa/Cairo"
                }`}
              >
                <PrimaryButton
                  classBtn={"center"}
                  btnType={"submit"}
                  text={"Download Account PDF"}
                  style={{
                    textTransform: "capitalize",
                    minWidth: "170px",
                    borderRadius: "5px",
                    color: config.SECONDARY_COLOR,
                    backgroundColor: config.PRIMARY_COLOR,
                    marginRight: "5px",
                  }}
                />
              </a> */}
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Team Code:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.code}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Team Name:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Category:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.category?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Age Group:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.category?.ageGroup?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Organization Name:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.account?.organizationName}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Account Code:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.account?.code}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Coach Name:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.coach?.name}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Coach Contact Number:{" "}
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "20px" },
                  fontWeight: "400",
                  marginTop: "10px",
                  display: "inline",
                }}
              >
                {profile?.coach?.contactNumber}
              </Typography>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "17px", md: "20px" },
                fontWeight: "500",
                marginTop: "10px",
              }}
            >
              Team Members:{" "}
            </Typography>

            <TableContainer
              component={Paper}
              sx={{
                marginTop: "10px",
              }}
            >
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member Name
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member National Id
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member Birthday
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ minWidth: "150px" }}
                    >
                      Member Age
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {profile?.members?.map((member) => (
                    <StyledTableRow key={member.name}>
                      <StyledTableCell align="center">
                        {member.name}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {member?.nationalId ?? "-"}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {member?.birthday?.split("T")?.at(0)}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {member?.age} years
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="greyBoxVer">
            {/* <Typography
              sx={{
                color: "primary.main",
                fontSize: { xs: "28px", md: "35px" },
                fontWeight: "500",
                marginBottom: "10px",
              }}
            >
              Welcome {profile?.admin?.name}!
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              This is your central hub for managing registrations in the{" "}
              <strong>
                {config.APP_NAME == "Code Reg"
                  ? "Code Challenge Competition"
                  : "WeDo Challenge Competition"}
              </strong>
              . From here, you can efficiently oversee your teams, participants,
              coaches, and payments. Navigate the system with ease and ensure a
              smooth registration process for your organization.
            </Typography> */}

            <Typography
              sx={{
                fontSize: { xs: "16px", md: "20px" },
                fontWeight: "600",
              }}
            >
              Need Assistance?
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
              }}
            >
              For technical issues or system-related questions, reach out to{" "}
              <a
                href="mailto:support@the-aichallenge.org"
                style={{ textDecoration: "underline" }}
              >
                support@the-aichallenge.org
              </a>{" "}
              or send us a message on our{" "}
              <a
                target="_blank"
                href="https://wa.me/+201500333864"
                style={{ textDecoration: "underline" }}
              >
                WhatsApp
              </a>
              .
            </Typography>
          </div>
        </div>
      ) : (
        <div className="loadingBox">
          <PulseLoader color={config.PRIMARY_COLOR} />
        </div>
      )}
    </div>
  );
}

export default Profile;
